<template>
  <div class="change-club">
    <ul class="breadcrumb">
      <li><router-link to="/">Главная</router-link></li>
      <li class="active"><router-link to="/changeClub">Выбор филиала</router-link></li>
    </ul>
    <div class="page_header">
      <div class="page_header--title">
        Выбор филиала
      </div>
    </div>

    <div class="page_content">
      <club-list
          :clubs="clubs"
          :on-club-select="changeCurrentClub"
      />
    </div>
  </div>
</template>

<script>
import ClubList from "../components/ClubList";
import { useToast } from "vue-toastification";

export default {
  name: 'ChangeClub',
  components: { ClubList },
  data() {
    return {
      clubs: []
    };
  },
  setup() {
    const toast = useToast();
    return { toast }
  },
  created() {
    this.loadClubs();
  },
  methods: {
    async loadClubs() {
      try {
        const response = await this.$store.dispatch('optionsClub');
        this.clubs = response.data;
      } catch (error) {
        this.toast.error("Ошибка при загрузке филиалов: " . error);
      }
    },
    async changeCurrentClub(id) {
      try {
        const result = await this.$api.user.changeCurrentClub(id);
        if (result.data && result.data.status == 'success') {
          window.location.reload();
        } else {
          this.toast.error("Ошибка при смене филиала");
        }
      } catch (error) {
        this.toast.error("Ошибка при смене филиала");
      }
    }
  }
}
</script>
